const PhotosPage = () => {
  return <div>Photos Page</div>;
}
export default PhotosPage;